import React, { Component } from 'react';
import TableList from 'src/Components/TableList/TableList';
import SearchFieldGE from 'src/Components/SearchFieldGE/SearchFieldGE';
import ErrorScreen from 'src/Components/ErrorScreen/ErrorScreen';
import { getCustomers, updateCustomerPagination, resetCustomerData } from 'src/Actions/Customers/customerAction';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import PulseLoader from 'react-spinners/PulseLoader';
import icon from 'src/Assets/Images/loadIssue_Illustration.svg';
import './styles.scss';
import { NATIVE_REDIRECT } from 'src/Config/constants';

class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      totalPages: 0,
      subscriptionList: [],
      sortByAsc: true,
      searchKey: '',
      hasSearchUpdated: false,
      pageNumber: 1,
    }
  }

  componentDidMount() {
    const nativeRedirectComponent = window.localStorage.getItem(NATIVE_REDIRECT);
    if (nativeRedirectComponent) {
      window.localStorage.removeItem(NATIVE_REDIRECT);
      this.props.history.push(nativeRedirectComponent)
    }
    window.scrollTo(0, 0);
    const sort = this.state.sortByAsc ? 'ASC' : 'DESC';

    this.props.getCustomers({ pagenumber: 1, sort });
  }
  componentDidUpdate(prevProps) {
    let { subscriptionLicenseList } = this.props.customer.customer;
    const existingItems = this.state.subscriptionList;

    if (prevProps.customer.customer !== this.props.customer.customer) {
      if (subscriptionLicenseList && subscriptionLicenseList.length > 0) {
        this.setState({
          isLoading: false,
          subscriptionList: existingItems ? existingItems.concat(subscriptionLicenseList) : subscriptionLicenseList,
        });
      }
      else {
        this.setState({
          isLoading: false,
          subscriptionList: subscriptionLicenseList,
        });
      }

      if (this.state.isLoading && this.props.customer.error && this.props.customer.error.status) {
        this.setState({
          isLoading: false,
          subscriptionList: [],
        });
      }
    }
  }

  getMoreCustomers = () => {
    let { pageNumber, totalPages, limit } = this.props.customer && this.props.customer.customer;
    let { searchKey, sortByAsc } = this.state;

    if (this.state.pageNumber <= totalPages) {
      const pagenumber = pageNumber + 1;

      if (pagenumber <= totalPages) {
        this.setState({
          pageNumber: pagenumber,
        });
      }

      //// if there is no searchkey then reset hasSearchUpdated
      if (searchKey === '' && this.state.hasSearchUpdated) {
        this.setState({
          hasSearchUpdated: false,
        });
      }

      this.props.updateCustomerPagination(pagenumber);

      const sort = sortByAsc ? 'ASC' : 'DESC';
      if (pagenumber <= totalPages) {
        this.props.getCustomers({ pagenumber, limit, sort, searchKey });
      }
    }
  };

  handleChange = (value) => {
    const searchQuery = value;
    this.setState({
      searchKey: searchQuery
    })
    let { pageNumber, limit } = this.props.customer && this.props.customer.customer;
    if (searchQuery.length >= 2 || searchQuery === "") {
      const sort = this.state.sortByAsc ? 'ASC' : 'DESC';

      this.setState({
        isLoading: true,
        subscriptionList: [],
        hasSearchUpdated: true
      });
      if (searchQuery === "") {
        this.props.getCustomers({ pagenumber: 1, sort });
      }
      else {
        this.props.getCustomers({ pageNumber, limit, sort, searchKey: searchQuery });
      }
    }
  }

  handleClear = (value) => {
    let { pageNumber } = this.props.customer && this.props.customer.customer;
    const sort = this.state.sortByAsc ? 'ASC' : 'DESC';
    this.setState({
      searchKey: value,
      isLoading: true,
      subscriptionList: [],
      hasSearchUpdated: true
    });
    this.props.getCustomers({ pageNumber, limit: 10, sort, searchKey: '' });
  }


  handleClickNavigate = dataRow => {
    const id = dataRow['activationKey'];
    this.props.resetCustomerData();
    this.props.history.push(`/customer/${id}`, { activationKey: id });
  }

  renderTableHeader = (count = 0) => {
    const { subscriptionList, searchKey } = this.state;
    const { t } = this.props;

    if (subscriptionList && subscriptionList.length > 0 || searchKey.length >= 0) {
      return (
        <div className="table-head">
          <span className="table-head-count">
            <span className="table-head-count-number">{count}</span> {t('accountHeading')}
          </span>
          <SearchFieldGE
            re={/^[a-zA-Z.' ]*$/}
            value={searchKey}
            placeholder={t('searchCustomerPlaceholder')}
            className="search-account-input"
            onChange={this.handleChange}
            onClear={this.handleClear}
          />
        </div>
      );
    }
  };

  renderModalities = (dataRow, uniqueKey, colValue, column) => {

    let data = colValue.map((val) => {

      if (val.modality && val.modality.toLocaleUpperCase() === 'ULTRASOUND') {
        return val.subModality && val.subModality.join(', ');
      }

      return val.modality
    }).join(', ');

    data = data.replace(/,\s*$/, "");

    return (
      <div key={`${uniqueKey}`} className={`account-container row-${column.widthInPercent}`} >
        <span className={`row__cell-label gutter-padding row__cell-label-wrap ${column.isHidden ? 'hide' : ''}`}>
          {data.length > 0
            ? data
            : ''}
        </span>
      </div>
    )
  }

  renderAccount = (dataRow, uniqueKey, colValue, column) => {
    return (
        <div key={`${uniqueKey}`} className={`account-container row-${column.widthInPercent}`} >
          <span className={'account-container-value gutter-padding'}>{colValue}</span>
          <span className={'account-container-addr  gutter-padding'}>{dataRow['street']}</span>
          <span className={'account-container-addr-line-2 gutter-padding'}>{`${dataRow['city']}, ${dataRow['state']}, ${dataRow['postalCode']} ${dataRow['country']}`}</span>
        </div>
      );
  }

  
  validateItems(objCount){
    if(objCount)
    {
    return objCount;
    }
    return 0;
    }

  getNavigateLink = (subscriptionList, searchKey) => {
    if(subscriptionList?.length === 1 && searchKey === "") return this.handleClickNavigate(...subscriptionList)
    else return null;
  }

  getErrorScreen = (subscriptionList, searchKey, totalPages, userLoggedOutData) => {
    if(subscriptionList?.length === 0 && searchKey.length === 0 && totalPages === 0)
      return <ErrorScreen data={userLoggedOutData} />
    else
      return null;
  }

  getSortBy = (sortByAsc) => {
    return sortByAsc;
  }

  getSort = (sortByAsc) => {
    if(sortByAsc) return 'ASC';
    else return 'DESC';
  }

  renderTableList = () => {
    let { t } = this.props;
    let { totalItems, limit, totalPages } = this.props.customer?.customer;
    let { isLoading, subscriptionList, pageNumber, searchKey } = this.state;
    localStorage.setItem('activeItem', 'Customers');

    const columns = [
      {
        key: 'Account', title: t("account"), fieldName: 'faciltiyName', widthInPercent: 'facilityName',
        maxWidth: 40, isSortRequired: true,
        dataType: 'custom',
        sortedItem: { sortField: 'facilityName', sortByAsc: true },
      },
      {
        key: 'Modality', title: t("modality"), fieldName: 'modalitySubModalityList', widthInPercent: 'Modality', maxWidth: 30, dataType: 'custom', isHidden: true
      },
      { key: 'parentAccount', title: t("customerColParentAcc"), fieldName: 'ultimateParent', widthInPercent: 'Modality', maxWidth: 30, dataType: 'string' },
    ];

    const isSortByAsc = this.getSortBy(this.state.sortByAsc);
    const sortedItem = {
      sortField: 'faciltiyName',
      sortByAsc: isSortByAsc,
    };

    const userLoggedOutData = {
      img: icon,
      header: t("noCustAccHeader"),
      subHeader: t("noCustAccSubheader")
    };

    const emptySearchMessage = {
      error: t("noAccFound"),
      msg: t("emptyPersonSearchSubtext")
    };

    const override = `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
  `;

    let clickNavigate = this.getNavigateLink(subscriptionList, searchKey); 
    let errorScreen = this.getErrorScreen(subscriptionList, searchKey, totalPages, userLoggedOutData);

    if (isLoading) 
      return <div className="customer-container-loading">
        <PulseLoader color={'#ffffff'} css={override} style={{ marginBottom: 24, marginTop: 24 }} />
      </div> 
    else  
      return <>
        {clickNavigate}
        {subscriptionList &&
          <div className='customer-container-table'>
            <TableList columnList={columns} dataList={subscriptionList} sortedItem={sortedItem}
              onSortHandler={(sortBy) => {
                this.setState({
                  isLoading: true,
                  sortByAsc: sortBy.sortByAsc,
                  subscriptionList: [],
                  pageNumber: 1,
                });
                let sort = this.getSort(sortBy.sortByAsc);
                this.props.getCustomers({ pageNumber, limit, sort, searchKey });
              }}
              handleClickNavigate={this.handleClickNavigate}
              pageNumber={pageNumber}
              totalItems={this.validateItems(totalItems)}
              totalPages={this.validateItems(totalPages)}
              searchKey={searchKey}
              loadMore={this.getMoreCustomers}
              emptySearchMessage={emptySearchMessage}
              customRendering={(colValue, column, uniqueKey, indexKey, dataRow) => {
                if (column.key === 'Account') {
                  return this.renderAccount(dataRow, uniqueKey, colValue, column); 
                }
                if (column.key === 'Modality') {
                  return this.renderModalities(dataRow, uniqueKey, colValue, column);
                }
              }}
            />
          </div>
        }
        {errorScreen}
      </>
  }
    
  render() {

    let { t } = this.props;
    let { totalItems } = this.props.customer?.customer;

    return (
      <div className="customer-wrapper-outer">
        {this.props.generic.initialLoad ? <div className='init-loader'>
          <PulseLoader color={'#ffffff'} style={{ marginBottom: 24, marginTop: 24 }} />
        </div> :
        <div className="customer-container">
          <div className='customer-container-wrapper'>
            <h3 className="customer-container-wrapper-heading">{t("customers")}</h3>
            {this.renderTableHeader(totalItems)}
            {this.renderTableList()}
          </div>
        </div>
        }
      </div>
    )
  }
}

export const mapStateToProps = ({ customer, generic }) => ({
  customer, generic
});

const mapDispatchToProps = (dispatch) => ({
  getCustomers: (payload) => dispatch(getCustomers(payload)),
  updateCustomerPagination: (pageNumber) => dispatch(updateCustomerPagination(pageNumber)),
  resetCustomerData: () => dispatch(resetCustomerData())
});

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Customer)));